/* Layout */
import Layout from '../../views/layout/Layout.vue'

const PushNotificationList = () => import(/* webpackChunkName: "notification-list" */ '@/views/push-notification/list')
const PushNotificationDetail = () => import(/* webpackChunkName: "notification-detail" */ '@/views/push-notification/detail')

export default [
  {
    path: '/push-notification',
    component: Layout,
    redirect: '/push-notification/list',
    name: 'push-notification',
    alwaysShow: true,
    meta: {
      title: 'pushNotification',
      icon: 'envelope',
    },
    children: [
      {
        path: 'create',
        component: PushNotificationDetail,
        name: 'push-notification-create',
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'push-notification',
        },
      },
      {
        path: 'list',
        component: PushNotificationList,
        name: 'push-notification-list',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'push-notification',
        },
      },
      {
        path: 'edit/:id',
        component: PushNotificationDetail,
        name: 'push-notification-detail',
        hidden: true,
        props: true,
        meta: {
          title: 'edit',
          icon: 'edit',
          accessibleName: 'push-notification',
        },
      },
    ],
  },
]
